import {remCalc} from '_themeUtils'

const mouseover = {
    Mouseover: {
        baseStyle: ({colorCta, fullHeightSection}) => ({
            wrapper: {
                position: 'relative',
                w: '100%',
                overflow: 'hidden',
                gridColumn: '1 / -1',
            },
            imageStack: {
                position: 'relative',
                w: '100%',
                h: fullHeightSection ? '100dvh' : 'auto',
            },
            imageDefault: {
                w: '100%',
                h: '100%',
                transition: 'opacity 1s ease',
            },
            imageSection: {
                position: 'absolute',
                top: 0,
                left: 0,
                w: '100%',
                h: '100%',
                transition: 'opacity 1s ease',
            },
            overlay: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 'spacing.6',
                w: '100%',
                textAlign: 'center',
            },
            title: {
                color: 'color.text.white',
                fontFamily: 'GTEesti',
                fontSize: remCalc(48),
                fontWeight: 300,
                letterSpacing: remCalc(3),
                lineHeight: remCalc(56),
                m: {base: `0 0 ${remCalc(24)} 0`, md: `0 0 ${remCalc(40)} 0`, lg: `0 0 ${remCalc(50)} 0`},
                p: 0,
            },
            list: {
                listStyleType: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minW: '50%',
            },
            listItem: {
                color: colorCta ?? 'color.text.white',
                textStyle: {base: 'paragraphMd'},
                letterSpacing: '0.2em',
                textTransform: 'uppercase',
                p: '1rem 0',
                sx: {
                    '& .cc-item': {
                        borderBottom: '2px solid transparent',
                        transition: 'border-color 0.4s ease',
                        pb: '0.2rem',
                    },
                    '& .cc-item:hover': {
                        borderBottomColor: colorCta ?? 'white',
                    },
                },
            },
        }),
    },
}

export default mouseover
